import { memo, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, ElasticModal, Search } from 'basic-components';
import { DraggableList } from 'primary-components';

import ColumnItem from './ColumnItem';

import { When } from 'react-if';

import './ColumnModal.scss';

const ColumnsModal = ({ columns, onClose, onSave }) => {
  const [localColumns, setLocalColumns] = useState(columns),
        [searchQuery, setSearchQuery] = useState(''),
        swapIsHidden = useCallback(columnKey => setLocalColumns(columns => columns.map(column => column.filterKey === columnKey ? { ...column, isHidden: !column.isHidden } : column)), []),
        onDragAndDrop = useCallback(({ from, to }) => setLocalColumns(columns => columns.moveItem(from, to)), []),
        filteredColumns = useCallback(column => column.label.toLowerCase().includes(searchQuery.toLowerCase()), [searchQuery]),
        footer = useMemo(() => (
          <div className="ng-office-app__authed__content__results__column-selector__footer">
            <Button
                onClick={onClose}
                size="small"
                variant="secondary" 
            >
              Cancel
            </Button>
            <Button
                
                onClick={() => onSave(localColumns)}
                size="small"
            >
              Save
            </Button>
          </div>
        ), [localColumns, onClose, onSave])

  return (
    <ElasticModal
        footer={footer}
        onClose={onClose}
        title="Columns"
    >
      <div className="ng-office-app__authed__content__results__column-selector">
        <div className="ng-office-app__authed__content__results__column-selector__search">
          <Search
              autoFocus 
              defaultValue={searchQuery}
              onSearch={setSearchQuery}
              placeholder="Search columns..." 
              searchDelay={0} 
              variant="outline"
          />
        </div>
        <div 
            className="ng-office-app__authed__content__results__column-selector__content" 
        >
          <When condition={localColumns.length > 0}>
            {() => (
              <div className="ng-office-app__authed__content__results__column-selector__content__section">
                <div className="ng-office-app__authed__content__results__column-selector__content__section__body">
                  <DraggableList>
                    {localColumns.filter(filteredColumns).map((column, columnIndex) => (
                      <ColumnItem 
                          columnName={column.label}
                          isDragDisabled={searchQuery.length > 0}
                          isHidden={column.isHidden}
                          isNotAvailable={column.isNotAvailable}
                          isSelectedAsFilter={column.isSelectedAsFilter}
                          itemIndex={columnIndex} 
                          key={column.filterKey}
                          onDragAndDrop={searchQuery ? undefined : onDragAndDrop}
                          swapIsHidden={() => swapIsHidden(column.filterKey)}
                      />
                    ))}
                  </DraggableList>
                </div>
              </div>
            )}
          </When>
        </div>
      </div>
    </ElasticModal>
  )
}

ColumnsModal.propTypes = {
  columns: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
}

export default memo(ColumnsModal)
